import { call, put, takeLatest } from "redux-saga/effects";

import { getComments } from "../../../services/comments.service";

const commentsReducer = (state = [], { type, payload }) => {
  switch (type) {
    case "FETCH_RECENTS_COMMENTS":
      return {
        ...state,
        isLoading: true,
      };
    case "FETCH_RECENT_COMMENTS_SUCCESS":
      return {
        ...state,
        listComments: payload.comments,
        isLoading: false,
      };
    case "FETCH_RECENT_COMMENTS_ERROR":
      return {
        ...state,
        error: payload.error,
        isLoading: false,
      };
    default:
      return state;
  }
};

function* getRecentsComments() {
  try {
    const response = yield call(getComments);

    yield put({
      type: "FETCH_RECENT_COMMENTS_SUCCESS",
      payload: {
        comments: response.data,
      },
    });
  } catch (error) {
    yield put({
      type: "FETCH_RECENT_COMMENTS_ERROR",
      payload: {
        error,
      },
    });
  }
}

function* commentsSaga() {
  yield takeLatest("FETCH_RECENTS_COMMENTS", getRecentsComments);
}

export { commentsSaga, commentsReducer };
